import { render } from "./ReportDiscounts.vue?vue&type=template&id=600e84c6&scoped=true"
import script from "./ReportDiscounts.vue?vue&type=script&lang=js"
export * from "./ReportDiscounts.vue?vue&type=script&lang=js"

import "./ReportDiscounts.vue?vue&type=style&index=0&id=600e84c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600e84c6"]])

export default __exports__